class Form {
  constructor() {
    this.ageInput = document.querySelector(".age-conditional input");
    this.guardianInputs = document.querySelectorAll(".pg-conditional");
    this.events();
  }

  events() {
    if (this.ageInput) {
      this.ageInput.addEventListener("input", e => {
        this.guardianInputs.forEach(el => {
          if (this.ageInput.value < 18) {
            this.showGuardian(el);
          }
          if (this.ageInput.value >= 18) {
            this.hideGuardian(el);
          }
        });
      });
    }
  }
  
  showGuardian(el) {
    el.classList.add("pg-conditional--active");
    el.setAttribute("aria-expanded", "true");
    el.querySelector("input").required = true;
  }

  hideGuardian(el) {
    if (el.classList.contains("pg-conditional--active")) {
      el.classList.remove("pg-conditional--active");
      el.setAttribute("aria-expanded", "false");
      el.querySelector("input").required = false;
    }
  }

  showError(input) {
    input.nextElementSibling.classList.add("error--active");
  }
  hideError(input) {
    input.nextElementSibling.classList.remove("error--active");
  }
}

export default Form;
